<template>
  <!-- Save Card Modal Structure -->
  <div id="save_card" class="modal services">
    <div class="modal-header">
      <!-- <a class="modal-close waves-effect btn-small waves-green right">x</a> -->
      <!-- <img src="ui/img/logo.png" width="18%" class="responsive-img"> -->
    </div>
    <div class="modal-content">
      <h5>Save card details</h5>
      <p>Would you like to use this card for future transactions?</p>
      <div class="row">
        <button
          type="button"
          @click="saveCard('yes')"
          class="btn-small"
          style="padding: 1px 15px; margin-right: 10px; font-size: 11px;"
        >
          Yes
        </button>
        <button
          type="button"
          @click="saveCard('no')"
          class="btn-small"
          style="padding: 1px 15px; font-size: 11px;"
        >
          No
        </button>
      </div>
    </div>
  </div>
  <!-- Save Card Modal Structure -->
</template>
<script>
export default {
  mounted() {
    // this.initModal()
  },
  data() {
    return {
      loading: false,
      modalInstance: {}
    }
  },
  methods: {
    initModal() {
      // initialize modal for the document
      const option = { dismissible: false, preventScrolling: true }
      var elems = document.querySelectorAll('.modal.services')
      var instances = M.Modal.init(elems, option)
      this.modalInstance = instances
    },
    saveCard(option) {
      this.$emit('saveCard', option)
    }
  }
}
</script>
<style scoped>
.modal .modal-content {
  padding: 0px 24px;
}
.modal.services {
  transform: translate(0%, -50%) !important;
  width: 42%;
  top: 50% !important;
}
.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 20px 0px;
}
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 600px) {
  .modal.services {
    transform: translate(0%, -50%) !important;
    width: 100%;
    top: 50% !important;
  }
}
.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.cardText span {
  font-size: 1rem;
  line-height: 120%;
}
</style>
